module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "yesnoonequestionmultilang"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v("Scenario Name")]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.scenario.name),
      expression: "scenario.name"
    }],
    staticClass: "input",
    attrs: {
      "type": "text",
      "placeholder": "Enter Scenario Name"
    },
    domProps: {
      "value": (_vm.scenario.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.scenario, "name", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('local-voice', {
    attrs: {
      "locale": _vm.scenario.parameters.locale,
      "vendor": _vm.scenario.parameters.vendor,
      "voiceName": _vm.scenario.parameters.voiceName
    },
    on: {
      "update:locale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:vendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:voiceName": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:voice-name": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      }
    }
  }), _vm._v(" "), _c('answer', {
    attrs: {
      "answer-title": "Question",
      "answer-theme": "mainQuestion",
      "answer-audio-id": _vm.scenario.parameters.mainQuestionId,
      "answer-audio": _vm.scenario.parameters.mainQuestionAudio,
      "answer-text": _vm.scenario.parameters.mainQuestionText,
      "answer-vendor": _vm.scenario.parameters.vendor,
      "answer-locale": _vm.scenario.parameters.locale,
      "answer-speaker": _vm.scenario.parameters.voiceName,
      "answer-emotion": _vm.scenario.parameters.mainEmotion,
      "answer-speed": _vm.scenario.parameters.mainSpeed,
      "answer-generation-type": _vm.scenario.parameters.mainQuestionAudioGenerationType,
      "is-saved": _vm.scenario.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudioId": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionId", $event)
      },
      "update:answer-audio-id": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionId", $event)
      },
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionText", $event)
      },
      "update:answerVendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answer-vendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answerLocale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answer-locale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answerSpeaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answer-speaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answerEmotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainEmotion", $event)
      },
      "update:answer-emotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainEmotion", $event)
      },
      "update:answerSpeed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainSpeed", $event)
      },
      "update:answer-speed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainSpeed", $event)
      },
      "update:answerGenerationType": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudioGenerationType", $event)
      },
      "update:answer-generation-type": function($event) {
        return _vm.$set(_vm.scenario.parameters, "mainQuestionAudioGenerationType", $event)
      },
      "generateAudioHandler": _vm.setMainAudio,
      "changeGenerationType": _vm.changeMainGenerationType
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "second-layer positive-scenario"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "wordsEditor",
    class: _vm.wordsEditorClass(_vm.scenario.parameters.yesLocalizedVariants)
  }, [_c('vue-tags', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var tag = ref.tag;
        var removeTag = ref.removeTag;
        var inputEventHandlers = ref.inputEventHandlers;
        var inputBindings = ref.inputBindings;

        return _c('div', {
          staticClass: "tags-input tags are-large"
        }, [_vm._l((_vm.scenario.parameters.yesLocalizedVariants), function(tag) {
          return _c('span', {
            staticClass: "tags-input-tag tag is-large"
          }, [_vm._v("\n                  " + _vm._s(tag) + "\n                  "), _c('button', {
            staticClass: "tags-input-remove delete",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return removeTag(tag)
              }
            }
          })])
        }), _vm._v(" "), _c('div', {
          staticClass: "control tags-input-text-div"
        }, [_c('input', _vm._g(_vm._b({
          staticClass: "tags-input-text input",
          attrs: {
            "placeholder": "добавте ответы \"Да\""
          }
        }, 'input', inputBindings, false), inputEventHandlers))])], 2)
      }
    }]),
    model: {
      value: (_vm.scenario.parameters.yesLocalizedVariants),
      callback: function($$v) {
        _vm.$set(_vm.scenario.parameters, "yesLocalizedVariants", $$v)
      },
      expression: "scenario.parameters.yesLocalizedVariants"
    }
  })], 1), _vm._v(" "), _c('answer', {
    attrs: {
      "answer-title": "",
      "answer-theme": "yes",
      "answer-audio-id": _vm.scenario.parameters.onYesId,
      "answer-audio": _vm.scenario.parameters.onYesAudio,
      "answer-text": _vm.scenario.parameters.onYesText,
      "answer-vendor": _vm.scenario.parameters.vendor,
      "answer-locale": _vm.scenario.parameters.locale,
      "answer-speaker": _vm.scenario.parameters.voiceName,
      "answer-emotion": _vm.scenario.parameters.onYesEmotion,
      "answer-speed": _vm.scenario.parameters.onYesSpeed,
      "answer-generation-type": _vm.scenario.parameters.onYesAudioGenerationType,
      "is-saved": _vm.scenario.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudioId": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesId", $event)
      },
      "update:answer-audio-id": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesId", $event)
      },
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesText", $event)
      },
      "update:answerVendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answer-vendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answerLocale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answer-locale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answerSpeaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answer-speaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answerEmotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesEmotion", $event)
      },
      "update:answer-emotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesEmotion", $event)
      },
      "update:answerSpeed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesSpeed", $event)
      },
      "update:answer-speed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesSpeed", $event)
      },
      "update:answerGenerationType": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudioGenerationType", $event)
      },
      "update:answer-generation-type": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onYesAudioGenerationType", $event)
      },
      "generateAudioHandler": _vm.setYesAudio,
      "changeGenerationType": _vm.changeYesGenerationType
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "second-layer negative-scenario"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "wordsEditor",
    class: _vm.wordsEditorClass(_vm.scenario.parameters.noLocalizedVariants)
  }, [_c('vue-tags', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var tag = ref.tag;
        var removeTag = ref.removeTag;
        var inputEventHandlers = ref.inputEventHandlers;
        var inputBindings = ref.inputBindings;

        return _c('div', {
          staticClass: "tags-input tags are-large"
        }, [_vm._l((_vm.scenario.parameters.noLocalizedVariants), function(tag) {
          return _c('span', {
            staticClass: "tags-input-tag tag is-large"
          }, [_vm._v("\n                  " + _vm._s(tag) + "\n                  "), _c('button', {
            staticClass: "tags-input-remove delete",
            attrs: {
              "type": "button"
            },
            on: {
              "click": function($event) {
                return removeTag(tag)
              }
            }
          })])
        }), _vm._v(" "), _c('div', {
          staticClass: "control tags-input-text-div"
        }, [_c('input', _vm._g(_vm._b({
          staticClass: "tags-input-text input",
          attrs: {
            "placeholder": "добавте ответы \"Нет\""
          }
        }, 'input', inputBindings, false), inputEventHandlers))])], 2)
      }
    }]),
    model: {
      value: (_vm.scenario.parameters.noLocalizedVariants),
      callback: function($$v) {
        _vm.$set(_vm.scenario.parameters, "noLocalizedVariants", $$v)
      },
      expression: "scenario.parameters.noLocalizedVariants"
    }
  })], 1), _vm._v(" "), _c('answer', {
    attrs: {
      "answer-title": "",
      "answer-theme": "no",
      "answer-audio-id": _vm.scenario.parameters.onNoId,
      "answer-audio": _vm.scenario.parameters.onNoAudio,
      "answer-text": _vm.scenario.parameters.onNoText,
      "answer-vendor": _vm.scenario.parameters.vendor,
      "answer-locale": _vm.scenario.parameters.locale,
      "answer-speaker": _vm.scenario.parameters.voiceName,
      "answer-emotion": _vm.scenario.parameters.onNoEmotion,
      "answer-speed": _vm.scenario.parameters.onNoSpeed,
      "answer-generation-type": _vm.scenario.parameters.onNoAudioGenerationType,
      "is-saved": _vm.scenario.isSaved,
      "client": _vm.scenario.client
    },
    on: {
      "update:answerAudioId": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoId", $event)
      },
      "update:answer-audio-id": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoId", $event)
      },
      "update:answerAudio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudio", $event)
      },
      "update:answer-audio": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudio", $event)
      },
      "update:answerText": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoText", $event)
      },
      "update:answer-text": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoText", $event)
      },
      "update:answerVendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answer-vendor": function($event) {
        return _vm.$set(_vm.scenario.parameters, "vendor", $event)
      },
      "update:answerLocale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answer-locale": function($event) {
        return _vm.$set(_vm.scenario.parameters, "locale", $event)
      },
      "update:answerSpeaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answer-speaker": function($event) {
        return _vm.$set(_vm.scenario.parameters, "voiceName", $event)
      },
      "update:answerEmotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoEmotion", $event)
      },
      "update:answer-emotion": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoEmotion", $event)
      },
      "update:answerSpeed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoSpeed", $event)
      },
      "update:answer-speed": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoSpeed", $event)
      },
      "update:answerGenerationType": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudioGenerationType", $event)
      },
      "update:answer-generation-type": function($event) {
        return _vm.$set(_vm.scenario.parameters, "onNoAudioGenerationType", $event)
      },
      "generateAudioHandler": _vm.setNoAudio,
      "changeGenerationType": _vm.changeNoGenerationType
    }
  })], 1), _vm._v(" "), _c('div', [_c('scenario-bar', {
    attrs: {
      "name": _vm.name,
      "is-saved": _vm.scenario.isSaved,
      "is-ready": true,
      "scenario": _vm.scenario
    },
    on: {
      "set": _vm.setScenario
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "title yesTitle"
  }, [_vm._v("Сообщение при ответе да")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "label"
  }, [_c('span', {
    staticClass: "title noTitle"
  }, [_vm._v("Сообщение при ответе нет")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2409dfff"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/scenarios/depricated/1_questionYesNo_i18.vue
// module id = 517
// module chunks = 42